import script from "./UploadItemDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadItemDescription.vue?vue&type=script&setup=true&lang=js"

import "./UploadItemDescription.vue?vue&type=style&index=0&id=87d1591e&lang=css"

const __exports__ = script;

export default __exports__